import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import { LoadingSpinner } from '../../../../components'
import StudentIdRow from './StudentIdRow.js'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const StudentIds = ({contextId}) => {
  const [currentState] = useStateValue()
  const [loading, setLoading] = useState(true)
  const [contextStudents, setContextStudents] = useState([])
  const [myedStudents, setMyedStudents] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(
          endpoints.getContextStudents({
            coursenum: currentState.contextToolsCoursenum,
            contextId: contextId,
        }))
        setContextStudents(resp.data.canvasStudents)
        setMyedStudents(resp.data.myedStudents)
        setLoading(false)
      } catch(err) {
        console.log(err)
      }
    }
    fetchData()
  }, [])

  return (
    <div className="card-myed">
      {loading ? (
        <div className="text-center">
          <LoadingSpinner style={{ fontSize: '50px' }} />
        </div>
      ) : (
        <React.Fragment>
          <h3>Student IDs</h3>
          <h4>Course {currentState.contextToolsCoursenum}</h4>
          <div className="table-responsive">
          <table className="w-100">
            <thead>
              <tr>
                <th />
                <th>MyEducator CourseMember</th>
                <th />
                <th>Saved Canvas ID</th>
                <th />
                <th>Canvas Students</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {myedStudents.map(student => (
                <StudentIdRow
                  key={student.myedId}
                  selectedStudent={student}
                  contextStudents={contextStudents}
                />
              ))}
            </tbody>
          </table>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

StudentIds.propTypes = {
  contextId: PropTypes.string,
}

export default StudentIds
